import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { hubNetwork } from '../mediaLabHubContent';

const HubNetwork = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 2, md: 3 }}>
      <SectionHeader
        overline={hubNetwork.overline}
        title={hubNetwork.title}
        subtitle={hubNetwork.subtitle}
        icon="public"
        align="left"
        maxWidth={720}
      />
      <Grid container spacing={3}>
        {hubNetwork.points.map((point) => (
          <Grid item xs={12} md={4} key={point.title}>
            <Box
              data-aos="fade-up"
              height="100%"
              p={3}
              borderRadius={3}
              bgcolor={alpha(theme.palette.common.white, 0.92)}
              border={`1px solid ${theme.palette.divider}`}
              boxShadow={`0 12px 32px ${alpha(theme.palette.common.black, 0.04)}`}
            >
              <Box mb={2}>
                <IconBadge icon={point.icon} variant="gradient" size={48} rounded="14px" />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
                {point.title}
              </Typography>
              <Typography color="textSecondary" sx={{ lineHeight: 1.7 }}>
                {point.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HubNetwork;
